import { css } from '@emotion/react'

import { tertiaryBodyCss } from '../../../../lib/styles/typography'
import { BP_SMALL_DOWN } from '../../../../lib/styles/breakpoints'

const modalBodyCss = css`
  grid-column: 1 / 3;
  grid-row: 2 / 2;
  margin-bottom: 1rem;
  /* A11Y-647: Enable text wrapping for responsive text resize and spacing */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  ${tertiaryBodyCss}
`
const mobileBodyCss = css`
  @media (${BP_SMALL_DOWN}) {
    margin: 16px;
  }
`

type ModalBodyProps = {
  /** Indicates whether the modal is in mobile mode */
  allowMobile?: boolean
  /** Content of the modal in the form of a React node */
  children: React.ReactNode
  /** Optional CSS class name for the modal */
  className?: string
}

const ModalBody = ({ allowMobile, children, className }: ModalBodyProps) => {
  const bodyCssSets = [modalBodyCss, allowMobile && mobileBodyCss]
  return (
    <div id="modal_body" className={className} css={bodyCssSets}>
      {children}
    </div>
  )
}

export default ModalBody
